import gsap from "gsap";

import EventEmitter from '../utils/EventEmitter';

export default class Hotspot extends EventEmitter {
  constructor (element) {
    super();

    this.element = element

    const [x, y] = this.element.dataset.position.split(",")

    gsap.set(this.element, { left: `${x}%`, top: `${y}%` });

    this.element.addEventListener("click", (e) => this.handleClick(e));
  }

  handleClick (event) {
    event.preventDefault();

    if (this.element.dataset.state === "active") return;

    const active = document.querySelector(".hotspot[data-state='active']");

    this.element.dataset.state = "active";

    if (active) active.dataset.state = "visible";

    this.trigger("click", [this.element])
  }
}